// What techs asked the office to add to the book (DEC-019) as DataTable columns (BL-189 consolidation;
// was AsksList): from a job, when it isn't there ("Ask the office to add it"). What they asked for and
// how often, who asked on which job, where it stands as a word (Waiting for an OK dashed under: it
// waits on someone; DESIGN.md §2), and what the office does with it: add it to the book, price it for
// just that job, or turn it down. Who can't change the book sees where each stands, without the actions.
import type { DataAction, DataColumn } from '../components/DataTable/DataTable.tsx';
import type { Ask } from '../pricebook/pricebook-data.ts';

export interface AskActions {
  /** The office's: with these, each row has its actions. */
  onAdd?: ((id: string) => void) | undefined;
  onJustThisJob?: ((id: string) => void) | undefined;
  onTurnDown?: ((id: string) => void) | undefined;
}

/** Asked by techs' columns; What to do only for whoever can change the book. */
export function askColumns({ onAdd, onJustThisJob, onTurnDown }: AskActions = {}): DataColumn<Ask>[] {
  const acts = (a: Ask): DataAction[] => [
    ...(onAdd ? [{ text: 'Add to the book', onPress: () => onAdd(a.id) }] : []),
    ...(onJustThisJob ? [{ text: 'Just this job', onPress: () => onJustThisJob(a.id) }] : []),
    ...(onTurnDown ? [{ text: 'Turn down', onPress: () => onTurnDown(a.id) }] : []),
  ];
  return [
    {
      id: 'what',
      label: 'What they asked for',
      rowHeader: true,
      nowrap: false,
      cell: (a) => ({
        text: a.what,
        look: 'strong',
        ...(a.times > 1 ? { lines: [{ text: `asked ${a.times} times` }] } : {}),
      }),
    },
    {
      id: 'who',
      label: 'Who, on which job',
      cell: (a) => ({ text: a.who, lines: [{ text: `${a.job} · ${a.when}` }] }),
    },
    {
      id: 'state',
      label: 'Where it stands',
      cell: (a) => ({ word: { word: a.state, tone: a.state === 'Waiting for an OK' ? 'wait' : 'ink' } }),
    },
    ...(onAdd || onJustThisJob || onTurnDown
      ? [
          {
            id: 'act',
            label: 'What to do',
            kind: 'action',
            cell: (a) => ({ actions: acts(a) }),
          } satisfies DataColumn<Ask>,
        ]
      : []),
  ];
}
